import React, { useState, useEffect, useContext } from "react";
import { connectBetPlacingPopover } from "./BetPlacingPopover.connect";
import { createPortal } from "react-dom";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import SVG_TimerIcon from "../../assets/images/svgs/timer.svg?react";
import { toastr } from "react-redux-toastr";
import { BetPopoverContext } from "../../context";
import { useSelector } from "react-redux";

const modalRoot = document.querySelector("#modal-root");

const BetPlacingPopover = ({
  open,
  betPlacing,
  auth,
  refBetPopover,
  cancel,
  actions,
  elementsParams,
}) => {
  const cancelBetPopover = useContext(BetPopoverContext);
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  const betDelayData = useSelector((state) => state.sportEvent?.betDelay);

  const [timer, setTimer] = useState(betPlacing.delay);

  // console.log(timer, betPlacing, "betPlacingbetPlacingbetPlacing");

  // useEffect(() => {
  //   setTimer(betDelayLoader());
  // }, [betPlacing.betDelay, open]);

  useEffect(() => {
    if (timer && betPlacing.betPlacingPopoverStage2 && open) {
      const time = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);
      return () => clearInterval(time);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer, betPlacing.betPlacingPopoverStage2, open]);

  function betDelayLoader() {
    let betDelay = 0;
    if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "4"
    ) {
      //Match Odds Cricket
      betDelay = parseInt(betDelayData?.market_bet_delay || 5);
    } else if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "1"
    ) {
      // Match Odds Football
      betDelay = parseInt(betDelayData?.market_bet_delay || 5);
    } else if (
      betPlacing.marketType == "MATCH_ODDS" &&
      betPlacing.eventTypeId == "2"
    ) {
      // Match Odds Tennis
      betDelay = parseInt(betDelayData?.market_bet_delay || 5);
    } else if (betPlacing.marketType == "Special") {
      // Bookmaker
      betDelay = parseInt(betDelayData?.market_bet_delay || 5);
    } else if (betPlacing.marketType == "SESSION") {
      // Session
      betDelay = parseInt(betDelayData?.session_bet_delay || 5);
    } else if (betPlacing.eventTypeId == "v9") {
      // Virtual
      betDelay = parseInt(betDelayData?.session_bet_delay || 5);
    } else if (betPlacing.eventTypeId == "b9") {
      betDelay = parseInt(betDelayData?.session_bet_delay || 5);
    } else {
      betDelay = 5;
    }
    return betDelay;
  }

  const profitType = () => (betPlacing.isBack ? "Profit" : "Liability");

  const profit = () => {
    const isFancy = betPlacing.marketType == "SESSION";
    const stake = betPlacing.stake
      ? isFancy
        ? getCurrencyFormat((betPlacing.stake * betPlacing.fancyPrice) / 100)
        : getCurrencyFormat(
            betPlacing.stake * betPlacing.priceActual - betPlacing.stake,
          )
      : "0.00";
    return stake;
  };

  const calculateStack = (market, isBack) => {
    if (isBack) {
      return Number(market?.ex?.availableToBack[0]?.price); // example stack value
    } else {
      return Number(market?.ex?.availableToLay[0]?.price); // different stack value
    }
  };

  const submit = async () => {
    if (betPlacing.confirmation) actions.setBetPlacingPopoverStage(false);
    else {
      actions.setBetPlacingPopoverStage(true);

      if (betPlacing.line) {
        if (betPlacing.price <= 1) {
          toastr.error("", "Bhaw cannot be less than 1.");
          return;
        }
        actions
          .requestSetFancyOrder(betPlacing)
          .then((res) => {
            // const text = getPlacingText(betPlacing, res)
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            actions.requestOpenBets(market.market_id);
            actions.requestUnMatchedBets();
            cancelBetPopover();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else if (e[0] && e[0][0] && e[0][0].description)
              toastr.error("", e[0][0].description);
            else toastr.error("", "Something went wrong");
          });
      } else if (betPlacing?.marketAll?.isHrBet) {
        let selection = betPlacing?.marketAll?.selection;
        let stake = Number(betPlacing.stake);
        let isBack = betPlacing?.isBack;
        let totalOdds = isBack
          ? betPlacing.marketAll?.totalOddsBack.toFixed(2)
          : betPlacing.marketAll?.totalOddsLay.toFixed(2);

        let equalAmount = isBack ? stake / totalOdds : stake / totalOdds;

        const newArray = selection.map((market) => ({
          selection_id: market.selectionId,
          selection_name: market.selection_name,
          market_id: market.market_id,
          odds: calculateStack(market, isBack),
          is_back: isBack ? 1 : 0,
          stack: Number(
            (calculateStack(market, isBack) * equalAmount).toFixed(0),
          ),
        }));

        actions
          .requestHROrder(newArray)
          .then((res) => {
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            cancelBetPopover();
            actions.requestOpenBets(market.market_id);
            actions.requestUnMatchedBets();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else toastr.error("", "Something went wrong");
          });
      } else {
        actions
          .requestSetOrder(betPlacing)
          .then((res) => {
            // const text = getPlacingText(betPlacing, res)
            if (res?.data) {
              res?.data?.status
                ? toastr.success("", res?.data?.msg)
                : toastr.error("", res?.data?.msg);
            }
            actions.requestOpenBets(market.market_id);
            actions.requestUnMatchedBets();
            cancelBetPopover();
          })
          .catch((e) => {
            cancelBetPopover();
            if (e?.msg) toastr.error("", e?.msg);
            else toastr.error("", "Something went wrong");
          });
      }
    }
    actions.setShowBetPlacingPopover(true);
  };

  const renderDataTable = () => {
    if (betPlacing?.marketType == "SESSION") {
      return (
        <div className=" grid grid-cols-12 border w-full border-ternary6 border-t-0 rounded-t-[8px]  text-xs font-normal">
          <div
            className={`col-span-12 grid grid-cols-12  font-normal rounded-t-[8px]  ${
              !!betPlacing?.isBack
                ? "bg-bg_ConfirmBetBackColor"
                : "bg-bg_ConfirmBetLayColor"
            }`}
          >
            <div className="col-span-3 text-center py-[5px]">RUNS</div>
            <div className="col-span-3 text-center py-[5px]">Odds(H-J)</div>
            <div className="col-span-3 text-center py-[5px]">Stake</div>
            <div className=" col-span-3 text-center py-[5px]">Liability</div>
          </div>
          <div className=" col-span-12 grid grid-cols-12  text-sm font-semibold leading-4 text-center">
            <div className="col-span-3 text-center py-2.5 border-r border-ternary6">
              {betPlacing.priceActual}
            </div>
            <div className="col-span-3 text-center py-2.5 border-r border-ternary6">
              {betPlacing?.fancyPrice}
            </div>
            <div className="col-span-3 text-center py-2.5 border-r border-ternary6">
              {betPlacing?.stake}
            </div>
            <div className="col-span-3 text-center py-2.5">
              <div>
                <span>{profit()}</span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className=" grid grid-cols-12 border w-full border-ternary6 border-t-0 rounded-t-[8px]  text-xs font-normal">
        <div
          className={`col-span-12 grid grid-cols-12  font-normal rounded-t-[8px]  ${
            !!betPlacing?.isBack
              ? "bg-bg_ConfirmBetBackColor"
              : "bg-bg_ConfirmBetLayColor"
          }`}
        >
          <div className="col-span-4 text-center py-[5px]">Odds</div>
          <div className="col-span-4 text-center py-[5px]">Stake</div>
          <div className=" col-span-4 text-center py-[5px]">Profit</div>
        </div>
        <div className=" col-span-12 grid grid-cols-12  text-sm font-semibold leading-4 text-center">
          <div className="col-span-4 text-center py-2.5 border-r border-ternary6">
            {betPlacing?.priceActual}
          </div>
          <div className="col-span-4 text-center py-2.5 border-r border-ternary6">
            {betPlacing?.stake}
          </div>
          <div className="col-span-4 text-center py-2.5">
            <div>
              <span>{profit()}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (betPlacing.betPlacingPopoverStage2)
      return (
        <>
          <div className=" flex flex-col gap-1 align-top items-center ">
            <span className=" relative w-max min-w-6 min-h-6 flex items-center justify-center p-2 pt-6 ">
              <span className=" absolute min-w-14 min-h-14 animate-spin rounded-full border-[2px] border-primary border-dashed"></span>
              <span className="font-semibold text-text_Ternary ">{timer}</span>
            </span>
            <span className=" font-semibold text-text_Ternary  mt-[4px]">
              Your bet is being processed...
            </span>
            <span className="text-text_Ternary  font-semibold">
              Please Wait...
            </span>
          </div>
        </>
      );
    return (
      <>
        <div className=" grid grid-flow-row gap-y-2 max-w-[100%] font-lato">
          <div className=" w-full">
            <div className=" text-lg font-medium text-text_Ternary 8 text-center ">
              <span>{betPlacing?.eventName}</span>
            </div>
          </div>
          <div
            className={` font-medium  w-full  flex items-center justify-center ${
              !!betPlacing?.isBack
                ? "text-text_BackTextColorConfirmBet"
                : "text-text_LayTextColorConfirmBet"
            } `}
          >
            <span>{!!betPlacing?.isBack ? "Backing" : "Laying"}</span>
            <span className=" ml-1">{betPlacing?.runnerName}</span>
          </div>
          {renderDataTable()}
          <div className=" w-full grid grid-cols-12 gap-x-1 gap-y-1x py-1">
            <button
              type="button"
              className="  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  px-5 py-2.5 flex items-center justify-center  col-span-6 min-h-10 text-sm rounded-md bg-transperent text-text_Danger font-medium border-[0.5px] border-danger cursor-pointer"
              onClick={cancel}
            >
              <span>Cancel Bet</span>
            </button>
            <div className="col-span-6">
              <button
                type="button"
                className=" leading-normal  overflow-hidden  transition duration-150 ease-in-out py-1 w-full relative flex items-start px-2.5 justify-start  min-h-10 text-sm rounded-md bg-placeBetBtnGrd text-text_Quaternary font-medium border-[0.5px] border-betSlipLoginBtnBg flex-col gap-x-1 disabled:bg-bg_DisableBackGroundColorfForPlaceBetBtn disabled:border-disableBackGroundColorfForPlaceBetBtn  cursor-pointer"
                disabled={
                  Number(betPlacing.stake) <= 0 ||
                  Number(betPlacing.priceActual) < 1.01
                }
                onClick={submit}
              >
                <span className=" text-text_Quaternary font-semibold">
                  Place Bet
                </span>
                <span className=" absolute top-[12px] right-[4px] text-xs flex items-center justify-center gap-x-[1px]">
                  <span>
                    <SVG_TimerIcon />
                  </span>
                  <span className=" font-bold">{betDelayLoader()}s</span>
                </span>
                <span className=" text-[10px] font-normal text-text_Quaternary">
                  <div>
                    <span>
                      {!!betPlacing?.isBack ? "Profit" : "Liability"} :{" "}
                    </span>
                    <span>{profit()}</span>
                  </div>
                </span>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (width >= 1024)
    return (
      <div className=" absolute top-0 left-0 bottom-0 right-0 h-full w-full bg-bg_PopUpParentBg flex items-center justify-center font-lato">
        <div className="popUpBoxShadow origin-center popUpOpenAnimation bg-bg_Quaternary  w-[95%] p-2 rounded-[12px]">
          {renderContent()}
        </div>
      </div>
    );

  return createPortal(
    <div
      id="popup-modal"
      className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh]     items-center justify-center  bg-bg_CasinoPopupBg"
    >
      <div className="z-2 popUpBoxShadow popUpOpenAnimation  absolute   w-[95%]  z-[900] bg-bg_Quaternary p-2 xs:p-5  rounded-md">
        {renderContent()}
      </div>
    </div>,
    modalRoot,
  );
};

export default connectBetPlacingPopover()(BetPlacingPopover);
